export default __webpack_public_path__ + "static/media/loading-sync.db45b119.svg";